export const version = 'berater-v1.19.0-rc1';